export default __webpack_public_path__ + "static/media/howItWorksHire1.38d46190.png";